/**
 * @generated SignedSource<<1bee3edb7f4a8a2f930cb7bf92a0a253>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgenticPlanTool$data = {
  readonly descriptionField: {
    readonly id: string;
    readonly richText: {
      readonly adfValue: {
        readonly json: AGG$JSON | null;
      } | null;
    } | null;
  } | null;
  readonly key: string;
  readonly " $fragmentType": "AgenticPlanTool";
};
export type AgenticPlanTool$key = {
  readonly " $data"?: AgenticPlanTool$data;
  readonly " $fragmentSpreads": FragmentRefs<"AgenticPlanTool">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AgenticPlanTool",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "concreteType": "JiraRichTextField",
      "kind": "LinkedField",
      "name": "descriptionField",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "concreteType": "JiraRichText",
          "kind": "LinkedField",
          "name": "richText",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraADF",
              "kind": "LinkedField",
              "name": "adfValue",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "json"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "932025c076221e1472b5ea5f24b73002";

export default node;
